import { ProductAPIService } from "./product";
import api from "../index";

export default new ProductAPIService(api);
